<div class="d-flex align-items-center">
    <telxl-avatar
        variant="end-customers"
        [name]="customer()?.name"
    />
    <div class="font-lg weight-medium truncate pe-2">
        {{ name() }}
    </div>
</div>
